import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[SeleccionarTextoInput]'
})
export class DSeleccionarTextoInput {

  // constructor(private el: ElementRef) { }

  // @HostListener('click') onClick() {
  //   const input = this.el.nativeElement as HTMLInputElement;
  //   input.select();
  // }
  constructor(private el: ElementRef) {}

  @HostListener('click')
  onClick() {
    const inputElement = this.el.nativeElement as HTMLInputElement;
    if (inputElement.value === '0') {
      inputElement.value = ''; // Borra el contenido del input
      // inputElement.dispatchEvent(new Event('input')); 
    }
  }
}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/directives/dseleccionar-texto-input.ts